module.exports = __webpack_public_path__ + "static/assets/26ca116a53cccd614ac5235876d2e6b3.svg";